import clsx from "clsx";
import { ChangeEvent } from "react";
import styles from "./Checkbox.module.scss";

interface CheckboxProps {
  id: string;
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  inverse?: boolean;
}

const Checkbox = ({ id, checked, onChange, label, inverse }: CheckboxProps) => {
  return (
    <div className={clsx(styles.checkbox, { [styles.inverse]: inverse })}>
      <input
        type="checkbox"
        id={id}
        name={id}
        value={id}
        checked={checked}
        onChange={onChange}
        className={styles.input}
      />
      <label htmlFor={id} className={styles.label}>
        <span className={styles.styledInput} />
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
